import React, { FunctionComponent } from 'react';
import Loadable from 'react-loadable';
import { BrowserRouter } from 'react-router-dom';
import 'styles/global.scss';
import { Loading } from 'components/Loading';

const AppHost = Loadable({
    loader: () => import('main/AppHost')
        .then(module => {
            return module.AppHost;
        }) as Promise<FunctionComponent>,
    loading: () => <Loading/>,
});

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <AppHost/>
        </BrowserRouter>
    );
};

export default App;
